import React, { useState } from 'react';
import { Shield, Check, Loader2 } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import axios from 'axios';
import { API } from '../../lib/axiosClient';

export const TwoFactorLogin = ({ tempToken, onSuccess, onCancel }) => {
  const { t } = useLanguage();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    if (code.length < 6) { setError(t('twoFactor.enter6DigitError')); return; }
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/auth/login`, {
        temp_token: tempToken, totp_code: code
      }, { _skipAuthRetry: true });
      onSuccess(res.data);
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
      setCode('');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && code.length === 6) verify();
  };

  return (
    <div className="space-y-5" data-testid="2fa-login-form">
      <div className="text-center space-y-2">
        <div className="w-14 h-14 mx-auto bg-emerald-500/10 rounded-2xl flex items-center justify-center">
          <Shield className="w-7 h-7 text-emerald-500" />
        </div>
        <h2 className="text-lg font-bold">{t('twoFactor.title')}</h2>
        <p className="text-sm text-slate-400">{t('twoFactor.enterCodeInstruction')}</p>
      </div>

      <div>
        <input type="text" maxLength={8} value={code}
          onChange={e => { setCode(e.target.value.replace(/[^a-zA-Z0-9-]/g, '')); setError(''); }}
          onKeyDown={handleKeyDown}
          placeholder={t('twoFactor.codePlaceholder')}
          className="w-full px-4 py-3 bg-slate-800 border border-slate-700 rounded-xl text-center text-xl tracking-[0.5em] font-mono focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500/30"
          autoFocus data-testid="2fa-login-code-input" />
      </div>

      {error && (
        <div className="p-2 bg-red-500/10 border border-red-500/20 rounded-lg">
          <p className="text-xs text-red-400 text-center">{error}</p>
        </div>
      )}

      <button onClick={verify} disabled={loading || code.length < 6} data-testid="2fa-login-verify-btn"
        className="w-full py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-xl transition-colors flex items-center justify-center gap-2 disabled:opacity-50">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
        {t('twoFactor.verifyBtn')}
      </button>

      <button onClick={onCancel} data-testid="2fa-login-cancel-btn"
        className="w-full py-2 text-sm text-slate-400 hover:text-white transition-colors">
        {t('twoFactor.backToLogin')}
      </button>

      <p className="text-center text-xs text-slate-500">{t('twoFactor.lostPhoneHint')}</p>
    </div>
  );
};
